import { Profile } from '@bioliberty/lifemind';
import { createContext } from 'react';

export const AuthenticatedUserContext = createContext<Profile>(null!);
